<template>
  <b-modal
    ref="addGanntSimpleModal"
    hide-footer
    centered
    :title="modalTitle"
    size="lg"
    @shown="shown = true"
    @hidden="shown = false"
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Title:"
      >
        <b-form-input
          type="text"
          v-model.trim="$v.title.$model"
          :class="{ 'is-invalid': $v.title.$error }"
          :disabled="inProgress"
          autocomplete="off"
        />
        <b-form-invalid-feedback
          v-if="!$v.title.required"
        >
          The Title is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Data source:"
      >
        <b-form-select
          v-model.trim="$v.dataSource.$model"
          :class="{ 'is-invalid': $v.dataSource.$error }"
          :disabled="inProgress"
          :options="dataSourceList"
        ></b-form-select>
        <b-form-invalid-feedback
          v-if="!$v.dataSource.required"
        >
          The DataSource is required
        </b-form-invalid-feedback>
      </b-form-group>
      <div v-if="dataSource">
        <b-form-group
          label="Name"
        >
          <b-form-select
            v-model.trim="$v.name.$model"
            :options="dataGridCols"
            :class="{ 'is-invalid': $v.name.$error }"
            :disabled="inProgress"
          />
          <b-form-invalid-feedback
            v-if="!$v.name.required"
          >
            Name is required
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Start date:"
        >
          <b-form-select
            v-model.trim="$v.start_date.$model"
            :options="dataGridCols"
            :class="{ 'is-invalid': $v.start_date.$error }"
            :disabled="inProgress"
          />
          <b-form-invalid-feedback
            v-if="!$v.start_date.required"
          >
            Start date is required
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="End date:"
        >
          <b-form-select
            v-model.trim="$v.end_date.$model"
            :options="dataGridCols"
            :class="{ 'is-invalid': $v.end_date.$error }"
            :disabled="inProgress"
          />
          <b-form-invalid-feedback
            v-if="!$v.end_date.required"
          >
            End date is required
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Assigned to:"
        >
          <b-form-select
            v-model.trim="$v.assignedTo.$model"
            :options="dataGridCols"
            :disabled="inProgress"
            :class="{ 'is-invalid': $v.assignedTo.$error }"
          />
          <b-form-invalid-feedback
            v-if="!$v.assignedTo.required"
          >
            Assigned to is required
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Color"
        >
          <b-form-select
            v-model.trim="$v.color.$model"
            :options="dataGridCols"
            :class="{ 'is-invalid': $v.color.$error }"
            :disabled="inProgress"
          />
          <b-form-invalid-feedback
            v-if="!$v.color.required"
          >
            Color is required
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <b-button
        variant="success"
        type="submit"
      >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
  import {mapState} from 'vuex'
  import {required, numeric} from 'vuelidate/lib/validators'
  // helpers
  import eventBus from '@/helpers/event-bus'
  // services
  import db from '@/services/db'

  let $ = window.$
  const typeValidate = (type) =>
    (value) => value.type === type

  export default {
    props: ['widgetsComputed'],
    data () {
      return {
        title: '',
        layout: 'b-card',
        dataSource: '',
        inProgress: false,
        name: '',
        start_date: '',
        end_date: '',
        assignedTo: '',
        color: ''
      }
    },
    computed: {
      ...mapState([
        'currentTab',
        'currentSubTab',
        'computedProps',
        'dataGrid_options'
      ]),
      modalTitle () {
        return 'Create Gantt Simple'
      },
      dataGridCols () {
        try {
          let cols = this.dataGrid_options[this.dataSource].meta
          let options = Object.keys(cols).map((el) => {
            return {
              value: {value: el, type: cols[el].type },
              text: el
            }
          });
          return options
        } catch (e) {
          return []
        }
      },
      dataSourceList () {
        try {
          const list = [
            ...Object.keys(this.dataGrid_options).map(el => {
              return {
                value: el,
                text: el
              }
            })
          ]
          return list
        } catch (e) {
          return []
        }
      }
    } ,
    methods: {
      save () {
        if (this.inProgress) return
        this.$v.$touch()
        if (this.$v.$invalid) return
        this.inProgress = true

        let data = {
          layout: 'b-card',
          title: this.title,
        //   id: this.id.value,
          name: this.name.value,
          start_date: this.start_date.value,
          end_date: this.end_date.value,
          assignedTo: this.assignedTo.value,
          color: this.color,
        //   percent: this.percent.value,
        //   duration: this.duration.value,
          // w: 12,
          // h: 6,
          layout: 'b-card',
          tab: this.currentTab,
          subtab: this.currentSubTab,
          dataSource: this.dataSource,
        }
        this.$store.commit('addProcess', {
          process: 'addWidget',
          message: 'Creating'
        })

        db.gantt_simple.create(data, (key) => {
          if (this.$refs.addGanntSimpleModal) this.$refs.addGanntSimpleModal.hide()
          this.title = null
          // this.dataSource = null
          this.$store.commit('deleteProcess', 'addWidget')
          // this.$store.commit('editWidget', {
          //   key,
          //   insert: true
          // })
          this.inProgress = false
          this.$nextTick(() => {
            this.$v.$reset()
          })
        })
      }
    },
    validations: {
      title: {
        required
      },
      dataSource: {
        required
      },
      name: {
        required
      },
      start_date: {
        required,
        typeValidate: typeValidate('date')
      },
      end_date: {
        required,
        typeValidate: typeValidate('date')
      },
      assignedTo: {
        required
      },
      color: {
        required
      },
    //   type: {
    //     required
    //   },
    //   duration: {
    //     required
    //   },
    //   percent: {
    //     required
    //   }
    },
    created () {
      eventBus.$on('addGanntSimple', (widgetType) => {
        if (this.$refs.addGanntSimpleModal) this.$refs.addGanntSimpleModal.show()
      })
    }
  }
</script>

<style lang="scss">
  @import '~$scss/globals';

  .templateEditor {
    height: 40vh;
    border: 1px solid $borderColor1;
  }

  .vue-codemirror {
    height: 100%;
  }

  .CodeMirror {
    height: 100%;
  }

  .gridstackSize {
    @include cf;

    &__item {
      @include span(6)

      &:first-child {
        padding-right: 10px;
      }

      &:last-child {
        padding-left: 20px;
      }

      @include breakpoint(max-width $screenSm) {
        @include span(12)
        &:first-child {
          padding-right: 0;
        }
        &:last-child {
          padding-left: 0;
        }
      }
    }
  }
</style>
